import { createSlice } from '@reduxjs/toolkit'

export const pendingSlice = createSlice({
	name: 'pendingSlice',
	initialState: {
		userLoading: true,
	},
	reducers: {
		change: (state, action) => {
			state.userLoading = action.payload
		},
	},
})

export const { change } = pendingSlice.actions

export default pendingSlice
